// import '~/packages/datakode/nuxt-datakode-utils/plugins/translation.ts'

export default {
    viewEntity: 'Visualiser',
    createEntity: 'Nouvel objet',
    organization: 'Structure',
    generic: {
        export: 'Exporter les données',
        add: 'Valider',
        cancel: 'Annuler',
        edit: 'Valider',
        custom_column: 'Action',
        organization: 'Structure',
        toaster: {
            DELETE: {
                success: {
                    text: '',
                    title: 'Supprimée avec succès.',
                },
            },
            PUT: {
                success: {
                    text: '',
                    title: 'Modifiée avec succès.',
                },
            },
            POST: {
                success: {
                    text: '',
                    title: 'Ajoutée avec succès.',
                },
            },
        },
        delete: {
            index: 'Supprimer',
            title: 'Confirmer la suppression',
            text: 'Êtes-vous sur de vouloir supprimer cet élément {k}?',
        },
        true: 'Oui',
        false: 'Non',
        noFileSaved: 'Pas de fichier',
        savedFiles: 'Fichier(s) sauvegardé(s)',
        imports: {
            page: 'Importer des données',
            index: 'Liste des imports',
            add: 'Ajouter un import',
            view: 'Détail de l\'import',
            edit: 'Validation de l\'import',
            delete: {
                index: 'Supprimer le fichier',
                title: 'Suppression de l\'import prêt',
                text: 'Le fichier a été validé, mais <b>l\'import n\'a pas été fait</b>. <br>Souhaitez-vous supprimer définitivement ce fichier ?',
            },
            title: 'Titre de l\'import',
            file_name: 'Nom du fichier',
            status: {
                index: 'Statut de l\'import',
                validated: 'Pret à être importé',
                done: 'Terminé',
                error: 'Erreur lors de l\'import',
            },
            toaster: {
                PUT: {
                    success: {
                        title: 'Import des entités',
                        text: 'L\'import {title} a été fait',
                    },
                },
                DELETE: {
                    success: {
                        title: 'Import des entités',
                        text: 'L\'import {title} a été supprimé',
                    },
                },
            },
        },
    },
}
